import * as IoC from 'inversify';
//import * as Projection from '../projection'

export const questionCommonTrackingModule = new IoC.ContainerModule((bind) => {
  // // projections
  // bind(Projection.QuestionStateProjection).toSelf().inSingletonScope();
})
